// Helpers for building Decisions (Section 4). The UI's draft starts from emptyDecision().
import type { Decision, GameState, PromptAnswer, PromptId } from '../core/types';

/**
 * Section 13 (stream M4a, E1-18): an open justice case starts answered with its proposal (the
 * justice policy's response), so "ask each case" lets the player override a case without
 * blocking the season; other open prompts start unanswered.
 */
function proposedAnswers(
  state: Partial<Pick<GameState, 'openPrompts'>>,
): Record<PromptId, PromptAnswer> {
  const out: Record<PromptId, PromptAnswer> = {};
  for (const p of state.openPrompts ?? [])
    if (p.kind === 'justice') out[p.id] = { kind: 'justice', response: p.proposed };
  return out;
}

export function emptyDecision(
  state: Pick<GameState, 'turn'> & Partial<Pick<GameState, 'openPrompts'>>,
): Decision {
  return {
    turn: state.turn,
    assignments: {},
    rations: {},
    policies: {},
    builds: [],
    eventChoices: proposedAnswers(state),
    promptAnswers: {},
    toolOverrides: {},
    triageOverrides: {},
    apprenticeships: {},
    savedPriorityOrders: null,
    myHousehold: null,
    renames: {},
  };
}
